// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4Qvxl","newExpiryDate":"styles_newExpiryDate__rxAfx","footer":"styles_footer__2E26O"};